import { Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaAccordionItem } from "@/components/rana-accordion-item";

export const ExportExplanation = () => {
  const intl = useIntl();
  return (
    <RanaAccordionItem
      title={intl.formatMessage({
        id: "map.export_how_to_title",
        defaultMessage: "How to export",
      })}
      m={0}
      borderBottomWidth={0}
    >
      <Text fontSize="sm" mb={1}>
        <FormattedMessage
          id="map.export_how_to_step_1"
          defaultMessage="1. Move and resize the selection box to choose the map area you want to export."
        />
      </Text>
      <Text fontSize="sm" mb={1}>
        <FormattedMessage
          id="map.export_how_to_step_2"
          defaultMessage="2. Choose a format: PNG/JPEG for images, or PDF for documents."
        />
      </Text>
      <Text fontSize="sm" mb={1}>
        <FormattedMessage
          id="map.export_how_to_step_3"
          defaultMessage="3. Export size controls output resolution: 1x is standard, 2x and 3x create sharper but larger files."
        />
      </Text>
      <Text fontSize="sm">
        <FormattedMessage
          id="map.export_how_to_step_4"
          defaultMessage="4. Set filename and dimensions, then click Export."
        />
      </Text>
    </RanaAccordionItem>
  );
};
